var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mailEditorBlock"},[_c('v-textarea',{staticClass:"hover",attrs:{"hide-details":"","auto-grow":"","single-line":"","flat":"","solo":"","placeholder":_vm.$t('EnterText')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }